export function epilogExtractHeightNumber(epilogNumber: string): number | null {
  // Staðfestum að epilogNumber sé 6 stafa strengur
  if (!/^\d{6}$/.test(epilogNumber)) {
    return 1;
  }

  // Sækjum 3. og 4. staf úr epilogNumber (hæðarnúmerið)
  const heightString = epilogNumber.substring(2, 4);

  // Breytum strengnum í heiltölu
  const heightNumber = parseInt(heightString, 10);

  // Skilum hæðarnúmerinu
  return heightNumber;
}

export function epilogExtractApartmentIdentity(input: string): number | null {
  // Staðfestum að input sé strengur með að lágmarki 4 tölustafi
  if (!/^\d{4,}$/.test(input)) {
    return null;
  }

  // Sækjum síðustu 4 stafina
  const lastFour = input.slice(-4);

  // Breytum þeim í tölu (parseInt fjarlægir leiðandi núll)
  const result = parseInt(lastFour, 10);

  return isNaN(result) ? null : result;
}

